<div class="c-progress">
  <div class="step" *ngFor="let step of steps" [ngClass]="step.class">
    <span>{{step[displayKey]}} </span>
  </div>
</div>
